<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Dashboard
            </h2>
        </template>

        <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
            <div class="px-4 py-5 bg-white sm:p-6 shadow-xl rounded-md">
                <h3 class="text-xl mb-5">Welcome {{ $page.props.user.name }}</h3>

                <ul>
                    <li class="my-1"><strong class="mr-2">Uploaded Contacts:</strong>{{ formatCount(partner.contacts) }}</li>
                    <li class="my-1"><strong class="mr-2">Uploaded Emails:</strong>{{ formatCount(partner.emails) }}</li>
                    <li class="my-1">
                        <strong class="mr-2">Your API Token:</strong>
                        <div class="inline-flex">
                            <input
                                class="border-gray-300 py-1 px-3 flex-grow text-sm font-mono"
                                type="text"
                                :value="partner.api_token"
                                readonly
                            >
                            <div class="border border-l-0 border-gray-300">
                                <copy-text :text="partner.api_token" mode="button" class="h-full px-2 hover:bg-gray-300"/>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import Welcome from '@/Jetstream/Welcome';
import CopyText from '@/Components/CopyText.vue';

export default {
    components: {
        CopyText,
        AppLayout,
        Welcome,
    },

    props: ['partner'],

    setup() {
        return {
            formatCount(count) {
                return new Intl.NumberFormat().format(count);
            },
        };
    },
};
</script>
